<template>
<div class="mobile-header">
  <a
  href="#"
  @click.prevent="toggleMenu"
  class="btn menu-toggle-btn"
  >
    <i class="fa fa-bars" aria-hidden="true"></i>
  </a>
      <h3>Evidenca ekoloških pridelovalcev in predelovalcev</h3>
</div>
</template>

<script>

export default {

   methods: {

    toggleMenu() {
      window.bus.$emit('menu/toggle');
    },

  },

};

</script>
